import script from "./RoomHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./RoomHistoryModal.vue?vue&type=style&index=0&id=e9485d9a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9485d9a"]])

export default __exports__